"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorDropDown = void 0;
const select_1 = require("client/components/material/select");
const store_1 = require("client/modules/inventory-order/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
// from distributor.tsx -- too lazy to import
// interface DistributorContact {
//   name: string;
//   email: string;
//   primaryContact: string;
//   secondaryContact: string;
//   role: string;
// }
// interface DistributorInventory {
//   id: number;
//   name: string;
//   price: string;
// }
// interface Distributor {
//   id: number;
//   distributor: string;
//   website?: string;
//   contacts: DistributorContact[];
//   inventories: DistributorInventory[];
// }
let DistributorDropDown = class DistributorDropDown extends React.Component {
    constructor() {
        super(...arguments);
        this.distributors = [];
        this.handleSelect = (value) => {
            const selectedDistributor = store_1.inventoryOrderStore.distributors
                ? store_1.inventoryOrderStore.distributors.find(d => d.id === Number(value))
                : null;
            this.props.onSelect && this.props.onSelect(selectedDistributor);
        };
    }
    async componentDidMount() {
        await store_1.inventoryOrderStore.listDistributors();
    }
    get availableOptions() {
        return store_1.inventoryOrderStore.distributors
            ? store_1.inventoryOrderStore.distributors.map(distributor => ({
                id: distributor.id,
                label: distributor.distributor,
                value: String(distributor.id)
            }))
            : [];
    }
    render() {
        const selectedDistributorId = this.props.selectedDistributor
            ? String(this.props.selectedDistributor.id)
            : "";
        return (React.createElement(select_1.MaterialSelect, { label: "Select distributor", value: selectedDistributorId, options: this.availableOptions, onSelect: this.handleSelect, searchable: true }));
    }
};
__decorate([
    mobx_1.observable
], DistributorDropDown.prototype, "distributors", void 0);
__decorate([
    mobx_1.computed
], DistributorDropDown.prototype, "availableOptions", null);
DistributorDropDown = __decorate([
    mobx_react_1.observer
], DistributorDropDown);
exports.DistributorDropDown = DistributorDropDown;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/components/distributor-drop-down/distributor-drop-down.tsx
// module id = 3565
// module chunks = 0